import { APIRequests } from '../../../config/api';
import { DataType } from '../../../types';
import { ListViewConfig, PageViewConfig } from './index';

export const userList: ListViewConfig = {
  title: "Users",
  apiRequest: APIRequests.UsersList,
  emptyMessage: "No users found",
  columns: [
    {
      name: 'timestamp',
      label: 'Created',
      type: DataType.Date,
      sorted: 'desc',
      editable: false
    },
    {
      name: 'first_name',
      label: 'First Name'
    },
    {
      name: 'last_name',
      label: 'Last Name'
    },
    {
      name: 'email',
      label: 'Email'
    },
    {
      name: 'phone_number',
      label: 'Phone Number',
    },
    {
      name: 'vitamin_status',
      label: 'Vitamin Status',
      helpText: 'Indicates the status of a users vitamin order',
      type: DataType.Select,
      fieldOptions: ['pending', 'ordered', 'idk']
    },
    {
      name: 'vitamin_production_status',
      label: 'Vitamin Production Status',
      helpText: 'Represents the status result of the order automation; an error, processing, or complete status'
    },
    {
      name: 'subscription_status',
      label: 'Subscription Status'
    },
    {
      name: 'vitamin_test_status',
      label: 'Blood Kit Test Status',
    },
    {
      name: 'blood_status',
      label: 'Blood Upload Status Name'
    },
    {
      name: 'dna_info',
      label: 'DNA Upload'
    },
    {
      name: 'dna_test_status',
      label: 'DNA Test Kit Status'
    },
    {
      name: 'omega_3',
      label: 'Omega 3'
    },
    {
      name: 'hormone_status',
      label: 'Cortisol Status',
    },
    {
      name: 'place_order_by_date',
      label: 'Place Order By',
      type: DataType.Date
    },
    {
      name: 'user_id',
      label: 'User Id',
    },
    {
      name: 'note',
      label: 'Note',
      type: DataType.LongText
    },
  ]
}

export const userEdit: PageViewConfig = {
  title: "email",
  sections: [
    {
      title: 'User Info',
      layout: 6,
      fields: [
        {
          name: 'first_name',
          label: 'First Name',
          editable: true
        },
        {
          name: 'last_name',
          label: 'Last Name',
          editable: true
        },
        {
          name: 'email',
          label: 'Email'
        },
        {
          name: 'phone_number',
          label: 'Phone Number',
          editable: true
        },
      ]
    },
    {
      title: "Vitamin Shipment",
      layout: 12,
      fields: [
        {
          name: 'place_order_by_date',
          label: 'Place Order By',
          editable: true,
          type: DataType.Date
        },
        {
          name: 'last_shipment_date',
          label: 'Last Shipment',
          editable: true,
          type: DataType.Date
        },
      ]
    },
    {
      title: "Status",
      layout: 6,
      fields: [
        {
          name: 'vitamin_status',
          label: 'Vitamin Status',
          editable: true,
          type: DataType.Select,
          fieldOptions: ['pending', 'ordered', 'idk']
        },
        {
          name: 'vitamin_production_status',
          label: 'Vitamin Production Status',
          editable: true
        },
        {
          name: 'subscription_status',
          label: 'Subscription Status',
          editable: true
        },
        {
          name: 'omega_3',
          label: 'Omega 3',
          editable: true
        },
        {
          name: 'vitamin_test_status',
          label: 'Blood Kit Test Status',
          editable: true,
        },
        {
          name: 'blood_status',
          label: 'Blood Upload Status Name',
          editable: true
        },
        {
          name: 'dna_info',
          label: 'DNA Upload'
        },
        {
          name: 'dna_test_status',
          label: 'DNA Test Kit Status',
          editable: true
        },
        {
          name: 'hormone_status',
          label: 'Cortisol Status',
          editable: true
        },
        {
          name: 'payment_status',
          label: 'Payment Status',
          editable: true
        },
      ]
    },
    {
      title: "Address",
      layout: 6,
      fields: [
        {
          name: 'ship_street1',
          label: 'Street 1',
        },
        {
          name: 'ship_city',
          label: 'City',
        },
        {
          name: 'ship_street2',
          label: 'Street 2',
        },
        {
          name: 'ship_state',
          label: 'State',
        },
        {
          name: 'ship_zip',
          label: 'Zip Code',
        },
      ]
    },
    {
      title: "System Information",
      layout: 6,
      fields: [
        {
          name: 'timestamp',
          label: 'Created',
          type: DataType.Date
        },
        {
          name: 'updated',
          label: 'Updated',
          type: DataType.Date
        },
      ]
    }
  ],
  related: [
    {
      title: "Orders",
      apiRequest: APIRequests.UsersListOrders,
      relatedFilter: "customer_id",
      emptyMessage: "No orders found",
      columns: [
        {
          name: 'id',
          label: 'Id'
        },
        {
          name: 'timestamp',
          label: 'Created'
        },
        {
          name: 'source_id',
          label: 'Order Id'
        },
      ]
    },
    {
      title: "Subscriptions",
      apiRequest: APIRequests.UsersListSubscriptions,
      emptyMessage: "No subscriptions found",
      relatedFilter: "customer_id",
      columns: [
        {
          name: 'id',
          label: 'Id'
        },
        {
          name: 'product_code',
          label: 'Product'
        },
        {
          name: 'current_period_started_at',
          label: 'Started'
        },
        {
          name: 'current_period_ends_at',
          label: 'Ends'
        },
        {
          name: 'paused_at',
          label: 'Paused On'
        },
        {
          name: 'updated_at',
          label: 'Updated On'
        },
      ]
    }
  ]
}